import { motion } from 'framer-motion';
import ImageCaption from './ImageCaption';

const slideVariants = {
  enter: (direction) => ({
    x: direction > 0 ? 1000 : -1000,
    opacity: 0,
    scale: 0.9,
  }),
  center: {
    x: 0,
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
    },
  },
  exit: (direction) => ({
    x: direction < 0 ? 1000 : -1000,
    opacity: 0,
    scale: 0.9,
    transition: {
      duration: 0.5,
      ease: 'easeIn',
    },
  }),
};

const CarouselSlide = ({ image, index }) => {
  return (
    <motion.div
      key={index}
      variants={slideVariants}
      initial="enter"
      animate="center"
      exit="exit"
      className="absolute inset-0"
    >
      {/* Image */}
      <motion.img
        src={image.src}
        alt={image.alt}
        className="w-full h-full object-cover"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 6, ease: 'linear' }}
        loading="eager"
      />

      {/* Caption */}
      <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
        <ImageCaption 
          title={image.title}
          caption={image.caption}
          animated={true}
        />
      </div>
    </motion.div>
  );
};

export default CarouselSlide;